import React, { Component } from 'react';
import { ActiveAscending, ActiveDescending, InactiveSort } from '../../assets/react-icons';
export class ThItem extends Component {

  state = {
    ascDirection: true
  }

  componentDidCatch(error, info) {
    console.log(error, info);
  }

  toggleSortDirection = () => {
    this.setState((prevState) => ({ ascDirection: !prevState.ascDirection }));
  }

  handleClick = () => {
    const { onClick, sortKey, sortable } = this.props;
    const direction = this.state.ascDirection ? 'asc' : 'desc';

    onClick(sortKey, direction, sortable);
    this.toggleSortDirection();
  }

  render() {

    const { children, activeSortKey, sortKey } = this.props;
    const { ascDirection } = this.state;

    return (
      <div className="th-item" onClick={this.handleClick}>
        <span>{children}</span>
        <span className="th-icon">
          {
            (activeSortKey === sortKey) ?
              ascDirection ?
                <ActiveAscending />
                :
                <ActiveDescending />
              : sortKey && <InactiveSort />
          }
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Table/ThItem.jsx